import { Box, Button, Flex, Image, Text } from '@chakra-ui/react';
import { BrokerAccountStatus } from 'enums/modules/brokerAccount/brokerAccountStatus';
import { t } from 'i18next';
import AppCard from 'presentation/components/shared/card/AppCard';
import { Color } from 'presentation/theme/colorScheme';
import { ButtonVariant } from 'presentation/theme/components/button';
import { FontSize } from 'presentation/theme/fontSizes';
import { MouseEvent, FC } from 'react';

interface Props {
  name: string;
  logo: string;
  accountNumber: string | null;
  status: BrokerAccountStatus;
  onDeleteClick: (e: MouseEvent) => void;
}

const ConnectedBrokerAccountListItem: FC<Props> = ({
  name,
  logo,
  accountNumber,
  status,
  onDeleteClick,
}) => {
  const isCustomIcon =
    logo.includes('.png') && !logo.includes('t-investments');

  const statusText = {
    [BrokerAccountStatus.Valid]: (
      <Text color={Color.Success} fontWeight={700}>
        {t('brokerAccountStatusValid')}
      </Text>
    ),
    [BrokerAccountStatus.Invalid]: (
      <Text color={Color.Error} fontWeight={700}>
        {t('brokerAccountStatusInvalid')}
      </Text>
    ),
    [BrokerAccountStatus.NotFilled]: (
      <Text color={Color.Error} fontWeight={700}>
        {t('brokerAccountStatusNotFilled')}
      </Text>
    ),
  };

  return (
    <AppCard
      p="40px"
      alignItems="center"
      borderRadius={10}
    >
      <>
        <Flex mb="10px">
          <Flex
            w="50px"
            h="50px"
            mr="24px"
            alignItems="center"
            justifyContent="center"
            flexShrink={0}
          >
            <Image
              src={logo}
              width={isCustomIcon ? '52px' : '50px'}
              height={isCustomIcon ? '52px' : '50px'}
              maxW="none"
              mixBlendMode={isCustomIcon ? 'multiply' : 'normal'}
            />
          </Flex>
          <Box flex="1">
            <Text fontSize={FontSize.lg} fontWeight={700} mb="5px">
              {name}
            </Text>
            <Text>{accountNumber}</Text>
          </Box>
          <Button
            variant={ButtonVariant.Danger}
            onClick={onDeleteClick}
          >
            {t('delete')}
          </Button>
        </Flex>
        {statusText[status]}
      </>
    </AppCard>
  );
};

export default ConnectedBrokerAccountListItem;
